export const TEXTS = {
  BUTTON_TEXT: 'Тариф видеовещания',
  CLOSE_TEXT: 'Закрыть',
};
